export default __webpack_public_path__ + "static/3-3e1bade5dc243dae21751cb12c83f116.jpg";